const environment = `${process.env.REACT_APP_GOUSTO_API_ORIGIN}`
const envGoustoHomePage = `${process.env.REACT_APP_GOUSTO_MAIN_URL}`
const zendeskBaseAPI = `${environment}/zendeskfetch/v1`

export const client = {
  help: '/',
  article: '/article',
  categories: '/categories',
  sections: '/sections',
  search: '/search',
}

export const zendeskAPI = {
  article: (articleID) => `${zendeskBaseAPI}/articles/${articleID}.json?include=categories,sections`,
  categorySections: (categoryID) => (
    `${zendeskBaseAPI}/categories/${categoryID}/sections.json?include=categories`
  ),
  categories: `${zendeskBaseAPI}/categories.json`,
  sectionArticles: (sectionID) => `${zendeskBaseAPI}/sections/${sectionID}/articles.json`,
  topArticles: `${zendeskBaseAPI}/top-articles.json`,
  articlesSearch: (query, perPage) => `${zendeskBaseAPI}/articles/search.json?query=${query}${perPage ? `&per_page=${perPage}` : ''}&include=sections`,
}

export const goustoAPI = {
  currentUser: `${environment}/user/current`,
  orders: `${environment}/user/current/orders`,
}

export const externalGoustoPages = {
  contactUs: '/get-help/contact',
  ssrDelivery: ({ userId, orderId }) => `/get-help/user/${userId}/order/${orderId}/delivery`,
  ssrIngredients: ({ userId, orderId }) => `/get-help/user/${userId}/order/${orderId}/ingredients`,
  ssrRecipeCards: ({ userId, orderId }) => `/get-help/user/${userId}/order/${orderId}/recipe-cards`,
  ssr: '/get-help',
  login: `/?target=${encodeURIComponent(`${envGoustoHomePage}/help-centre`)}#login`,
}
